export default __webpack_public_path__ + "static/media/Solend.5fceddd2.svg";